module.exports = __webpack_public_path__ + "8c7197699758498d7c68d7e9aecdb124.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/rmzxb_c.png
// module id = 244
// module chunks = 3